import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type WallboardPermissionErrorPageType from './ui/wallboard-permission-error-page/WallboardPermissionErrorPage.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyNotFoundErrorPage = lazy<ComponentType<{}>>(
	() =>
		import(
			/* webpackChunkName: "async-not-found-error-page" */ './ui/not-found-error-page/NotFoundErrorPage.tsx'
		),
);

export const NotFoundErrorPageAsync = () => (
	<Placeholder name="async-not-found-error-page" fallback={null}>
		<LazyNotFoundErrorPage />
	</Placeholder>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyWallboardPermissionErrorPage = lazy<typeof WallboardPermissionErrorPageType>(
	() =>
		import(
			/* webpackChunkName: "async-wallboard-permission-error-page" */ './ui/wallboard-permission-error-page/WallboardPermissionErrorPage.tsx'
		),
);

export const WallboardPermissionErrorPageAsync = () => (
	<Placeholder name="async-wallboard-permission-error-page" fallback={null}>
		<LazyWallboardPermissionErrorPage />
	</Placeholder>
);
